var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-subheader',{staticClass:"px-0 subheader",class:{'subheader__small': _vm.small},style:(("color: " + _vm.color + "; " + _vm.componentStyle)),attrs:{"inset":false}},[_vm._v(_vm._s(_vm.formattedText))])}
var staticRenderFns = []

export { render, staticRenderFns }